import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UiSettingsState {
  isSidebarCollapsed: boolean;
}

const initialState: UiSettingsState = {
  isSidebarCollapsed: false,
};

export const uiSettingsSlice = createSlice({
  name: "uiSettings",
  initialState,
  reducers: {
    toggleSidebar: (state) => {
      state.isSidebarCollapsed = !state.isSidebarCollapsed;
    },
    setSidebarCollapsed: (state, action: PayloadAction<boolean>) => {
      state.isSidebarCollapsed = action.payload;
    },
  },
  selectors: {
    selectIsSidebarCollapsed: (state) => state.isSidebarCollapsed,
  },
});

export const { toggleSidebar, setSidebarCollapsed } = uiSettingsSlice.actions;
export const { selectIsSidebarCollapsed } = uiSettingsSlice.selectors;
export const uiSettingsReducer = uiSettingsSlice.reducer;
